import {formattedPropertyModel, intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './ProgressFormatter.less';

export const DEFAULT_LEFT_COLOR = {r: 255, g: 105, b: 97};
export const DEFAULT_MIDDLE_COLOR = {r: 255, g: 179, b: 71};
export const DEFAULT_RIGHT_COLOR = {r: 119, g: 221, b: 119};

class GradientProgressFormatter extends React.PureComponent {
  render() {
    const {intl, value} = this.props;
    const decimalValue = utils.NumberUtils.roundToWantedDecimals(
      value * 100,
      2
    );
    const backgroundColor = utils.ColorUtils.getRGBLinearGradientColor(
      decimalValue,
      DEFAULT_LEFT_COLOR,
      DEFAULT_RIGHT_COLOR,
      DEFAULT_MIDDLE_COLOR
    );
    const propDefinition = new formattedPropertyModel.FormattedProperty({
      type: formattedPropertyModel.FORMATTED_PROPERTY_TYPE_PERCENT,
    });
    const formattedValue = formattedPropertyModel.FormattedProperty.formatValue(
      propDefinition,
      value,
      intl
    );
    return (
      <div
        className={styles.dlProgressFormatter}
        style={{backgroundColor, width: `${decimalValue}%`}}
      >
        <div className={styles.dlProgressFormatterValue}>{formattedValue}</div>
      </div>
    );
  }
}

GradientProgressFormatter.displayName = 'GradientProgressFormatter';

GradientProgressFormatter.propTypes = {
  intl: intlShape.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

GradientProgressFormatter.defaultProps = {
  value: undefined,
};

export default injectIntl(GradientProgressFormatter);
